import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { GTM_SPA_PAGE_EVENT, gtmDataLayerPush } from '../../utils/gtm';

function pushSpaPageGtm(pathnameWithSearch: string): void {
  gtmDataLayerPush({
    event: GTM_SPA_PAGE_EVENT,
    page_path: pathnameWithSearch,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
    page_title: typeof document !== 'undefined' ? document.title : undefined,
  });
}

function pushSpaPageGa4(measurementId: string, pathnameWithSearch: string): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', measurementId, {
    page_path: pathnameWithSearch,
    page_title: typeof document !== 'undefined' ? document.title : undefined,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
  });
}

export function useGoogleTagManager(): void {
  const location = useLocation();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (prevPath.current === path) return;
    const isFirstPage = prevPath.current === null;
    prevPath.current = path;

    if (window.__GTM_CONTAINER_ID__ || window.__MASTER_GTM_ID__) {
      pushSpaPageGtm(path);
    }
    const ga4 = window.__GA4_MEASUREMENT_ID__;
    if (ga4) pushSpaPageGa4(ga4, path);
    const masterGa4 = window.__MASTER_GA4_ID__;
    if (masterGa4 && masterGa4 !== ga4) pushSpaPageGa4(masterGa4, path);
    if (!isFirstPage && window.__META_PIXEL_ID__ && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);
}
